import { c as _c } from "react/compiler-runtime";
import { memo } from "react";
import type { Drop, ExtendedDrop } from "@/helpers/waves/drop.helpers";
import type { ActiveDropState } from "@/types/dropInteractionTypes";
import type { DropInteractionParams, DropLocation } from "../Drop";
import type { ApiDrop } from "@/generated/models/ApiDrop";
import MemeWinnerDrop from "@/components/memes/drops/MemeWinnerDrop";
import DefaultWinnerDrop from "./DefaultWinnerDrop";
import { useSeizeSettings } from "@/contexts/SeizeSettingsContext";
interface WinnerDropProps {
  readonly drop: ExtendedDrop;
  readonly previousDrop: Drop | null;
  readonly nextDrop: Drop | null;
  readonly showWaveInfo: boolean;
  readonly activeDrop: ActiveDropState | null;
  readonly showReplyAndQuote: boolean;
  readonly location: DropLocation;
  readonly dropViewDropId: string | null;
  readonly onReply: (param: DropInteractionParams) => void;
  readonly onQuote: (param: DropInteractionParams) => void;
  readonly onReplyClick: (serialNo: number) => void;
  readonly onQuoteClick: (drop: ApiDrop) => void;
  readonly onDropContentClick?: ((drop: ExtendedDrop) => void) | undefined;
  readonly parentContainerRef?: React.RefObject<HTMLElement | null> | undefined;
}
const WinnerDrop = props => {
  const $ = _c(4);
  const {
    isMemesWave
  } = useSeizeSettings();
  if (isMemesWave(props.drop.wave?.id?.toLowerCase())) {
    let t0;
    if ($[0] !== props) {
      t0 = <MemeWinnerDrop {...props} />;
      $[0] = props;
      $[1] = t0;
    } else {
      t0 = $[1];
    }
    return t0;
  }
  let t0;
  if ($[2] !== props) {
    t0 = <DefaultWinnerDrop {...props} />;
    $[2] = props;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  return t0;
};
export default memo(WinnerDrop);